import { supportedWebGateways } from './cashfreePayment';
export { openCashfree as openExamCashfree } from './cashfreePayment';
export const supportedExamGateways = supportedWebGateways;
export function rupeesToPaise(value) {
  const text = String(value ?? '').trim();
  if (!/^\d+(\.\d{1,2})?$/.test(text)) throw new Error('The server returned an invalid payment amount.');
  const [whole, fraction = ''] = text.split('.');
  const amount = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  if (!Number.isSafeInteger(amount) || amount < 0) throw new Error('The server returned an invalid payment amount.');
  return amount;
}
const scripts = new Map();
function loadScript(src, ready) {
  if (ready()) return Promise.resolve();
  if (scripts.has(src)) return scripts.get(src);
  const pending = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => ready() ? resolve() : reject(new Error('Payment checkout did not initialize.'));
    script.onerror = () => reject(new Error('Unable to load payment checkout.'));
    document.body.appendChild(script);
  }).catch(error => { scripts.delete(src); throw error; });
  scripts.set(src, pending);
  return pending;
}
export const loadExamRazorpay = () => loadScript('https://checkout.razorpay.com/v1/checkout.js', () => Boolean(window.Razorpay));
